var classes = {"promoBanner":"zHJqC","promoBannerSlide":"_2gfyC","inlineLink":"_7C-k2"};

export { classes as default };
